import { CalendarDaysIcon, ListBulletIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import React from "react";
import RP_Avatar from "../RP_Avatar";

const DashboardlistPatient = ({ patienten, goToDetails }) => {
  if (!patienten?.length) {
    return (
      <p className="rounded-xl border border-dashed border-wa-border bg-wa-panel/50 py-12 text-center text-sm text-wa-muted">
        Geen patiënten gevonden.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto rounded-xl border border-wa-border bg-wa-panel2 shadow-lg shadow-black/10">
      <table className="min-w-[640px] w-full divide-y divide-wa-border">
        <thead>
          <tr className="bg-wa-panel">
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-wa-muted sm:pl-6"
            >
              Naam
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-wa-muted"
            >
              <div className="flex items-center gap-2">
                Vragenlijsten
                <ListBulletIcon className="h-4 w-4 text-wa-muted" />
              </div>
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-wa-muted"
            >
              Eetdagboek
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-wa-muted"
            >
              <div className="flex items-center gap-2">
                Afspraak
                <CalendarDaysIcon className="h-4 w-4 text-wa-muted" />
              </div>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-wa-border bg-wa-panel2">
          {patienten.map((person) => (
            <tr
              className="cursor-pointer transition-colors hover:bg-wa-rowhover"
              key={person?.userdetails_user_id}
            >
              <td
                onClick={() => goToDetails(person)}
                className="whitespace-nowrap py-4 pl-4 pr-3 text-xs sm:pl-6 sm:py-5"
              >
                <div className="flex items-center">
                  <RP_Avatar
                    avatar={person?.userdetails_avatar}
                    size={11}
                    alt={person?.userdetails_full_name}
                  />
                  <div className="ml-3 min-w-0">
                    <div className="truncate font-medium text-wa-text">
                      {person?.userdetails_full_name}
                    </div>
                    <div className="mt-0.5 truncate text-wa-muted">
                      {person?.userdetails_email}
                    </div>
                  </div>
                </div>
              </td>
              <td
                onClick={() => goToDetails(person)}
                className="max-w-xs whitespace-normal px-3 py-4 text-xs text-wa-muted sm:py-5"
              >
                <ul className="space-y-1">
                  <li>
                    <span className="text-wa-text">Preintake: </span>
                    {person?.vragenlijsten_preintake_verstuur == 1 ? (
                      <span className="text-wa-accent">Verstuurd</span>
                    ) : (
                      <span className="text-red-400">Niet verstuurd</span>
                    )}
                  </li>
                  <li>
                    <span className="text-wa-text">Klacht: </span>
                    {person?.vragenlijsten_klacht_verstuur == 1 ? (
                      <span className="text-wa-accent">Verstuurd</span>
                    ) : (
                      <span className="text-red-400">Niet verstuurd</span>
                    )}
                  </li>
                  <li>
                    <span className="text-wa-text">Voeding: </span>
                    {person?.vragenlijsten_voeding_verstuur == 1 ? (
                      <span className="text-wa-accent">Verstuurd</span>
                    ) : (
                      <span className="text-red-400">Niet verstuurd</span>
                    )}
                  </li>
                </ul>
              </td>
              <td
                onClick={() => goToDetails(person)}
                className="whitespace-nowrap px-3 py-4 text-xs sm:py-5"
              >
                {person?.eetdagboek_title ? (
                  <span className="inline-flex max-w-[10rem] items-center truncate rounded-md border border-wa-accent/40 bg-wa-accentdeep/30 px-2 py-1 text-xs font-medium text-wa-text">
                    {person?.eetdagboek_title}
                  </span>
                ) : (
                  <span className="text-wa-muted">—</span>
                )}
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-xs text-wa-muted sm:py-5">
                <div className="flex flex-col gap-0.5">
                  <span className="text-wa-text">
                    {person?.appointment_date &&
                      moment(person?.appointment_date).format("DD/MM/YYYY HH:mm")}
                  </span>
                  <span>{person?.appointment_date && person?.appointment_type}</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardlistPatient;
